import axios from 'axios';
import { API_BASE } from './config';

export const fetchRestaurantOrders = ({ restaurantId, propertyId, status }) => {
  return axios.get(`${API_BASE}/orders`, {
    params: {
      restaurantId,
      propertyId,
      status,
    },
  });
};

export const updateRestaurantOrderStatus = (orderId, status, note, cancellationReason) =>
  axios.patch(`${API_BASE}/orders/${orderId}/status`, { status, note, cancellationReason });
